import { useEffect,useRef,useState } from 'react'
import { URL } from '../../common/api/urls';
import { useAxiosWithAuth } from '../../common/api/hooks/useAxiosWithAuth';
import {Snackbar, Box,Select,Typography,Container,CircularProgress,Alert,Button,MenuItem,FormControl,InputLabel, Tooltip, Grid, TextField} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import OptionsFooter from './components/options_footer';
import dayjs from 'dayjs';
// import { DatePicker} from 'antd';
import { TEXT_MSGS,USER_ROLE_FIELDS,SNACKBAR_AUTO_HIDE_DURATION,MenuProps,SNACKBAR_AUTO_HIDE_DURATION_SHORT } from '../../common/utility/constant';
import {styled, useTheme} from '@mui/material/styles';
import { WATERMARK_CONFIG } from '../../common/utility/constant';
import { ToolbarFixed } from '../../layouts/component.js';
import useAuth from '../../common/hooks/useAuth';
import ConfirmActionDialog from './components/confirm_dialog';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw'; // Allows rendering raw HTML like <img>
import mermaid from 'mermaid';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as TooltipJS,
  Legend
} from 'chart.js';

import { getUserListColumnDef } from '../../common/utility/user_list_columnDefs';

const ROW_HEIGHT=46;
const HEADER_HEIGHT=44;
const GROUP_HEADER_HEIGHT=30;
// import { CallCheckBoxRenderer,PutCheckBoxRenderer } from './components/options_table_renderer';
const gridOptions = {
  suppressColumnVirtualisation:true,
  suppressMovableColumns:true,
  suppressColumnMoveAnimation:true,
  // suppressRowVirtualisation:true,  // not more than 500 rows display because of this
  enableCellTextSelection:true,
  ensureDomOrder:true,
}
const frameworkComponents= {
  // userComponent: UserRenderer,
} 

const DateFormat = 'DD-MM-YYYY';
const FooterToolbar=styled(ToolbarFixed)(
    ({theme})=> `
    bottom:0px;
    justify-content:center;
    text-align:center;
    `
  )
export default function UserAdmin() {
  
    const navigate = useNavigate(); 
    const theme=useTheme();
    const from = "/login";
    const { auth } = useAuth();
    const [gridAPIOptions,setGridAPIOptions]=useState();
    const [columnAPIOptions,setColumnAPIOptions]=useState();
    const [orderId,setOrderId]=useState();
    const [refNo,setRefNo]=useState();
    const [emailId,setEmailId]=useState();
    const [userAdminQuery,setUserAdminQuery]=useState();
    const [planName,setPlanName]=useState();
    const [filterPlanName,setFilterPlanName]=useState();
    const [filterRoleName,setFilterRoleName]=useState();
    const [filterResourceName,setFilterResourceName]=useState();
    const [payType,setPayType]=useState();
    const [amount,setAmount]=useState();
    const [cancel,responseData,error,loaded,reset,executeAPI] = useAxiosWithAuth();
    const [cancelOrderReq,responseOrderReq,errorOrderReq,loadedOrderReq,resetOrderReq,getOrderStatus] = useAxiosWithAuth();
    const [cancelPlanSubReq,responsePlanSubReq,errorPlanSubReq,loadedPlanSubReq,resetPlanSubReq,getPlanSubStatus] = useAxiosWithAuth();
    const [cancelAdminQueryReq,responseAdminQueryReq,errorAdminQueryReq,loadedAdminQueryReq,resetAdminQueryReq,getUserAdminQueryResponse] = useAxiosWithAuth();
    const isAdmin=(auth.role.find(el=>el==USER_ROLE_FIELDS.ADMIN))?true:false;
    const gridRef = useRef();

    const [state, setState] = useState({
      isLoading: true,
      data: undefined,
      user_stats: undefined,
      // order_id: undefined,
      // reloadInerval: 5*60*1000, // 5 sec
    });

    const { isLoading, data, user_stats } = state

    const [msgState, setMsgState] = useState({
        open: false,
        msg:"" ,
        severity:"info"
    });
    const { open, msg, severity } = msgState;

    const [orderState, setOrderState] = useState({
        order_available: false,
        order_data: undefined,
        cca_data: undefined
    });
    const { order_available, order_data, cca_data } = orderState;

    const [planState, setPlanState] = useState({
      is_valid: false,
      user_data: undefined,
      sub_data: undefined,
      // planList: ["PREMIUM_MONTHLY_1", "PREMIUM_MONTHLY_6", "PREMIUM_MONTHLY_12", "PREMIUM_PLUS_MONTHLY_1", "PREMIUM_PLUS_MONTHLY_6", "PREMIUM_PLUS_MONTHLY_12"],
      planList: ['NSE_PREMIUM_MONTHLY_1', 'NSE_PREMIUM_MONTHLY_3', 'NSE_PREMIUM_MONTHLY_6', 'NSE_PREMIUM_MONTHLY_12', 'NSE_PREMIUM_STOCKS_MONTHLY_1', 'NSE_PREMIUM_STOCKS_MONTHLY_3', 'NSE_PREMIUM_STOCKS_MONTHLY_6', 'NSE_PREMIUM_STOCKS_MONTHLY_12', 'NSE_PREMIUM_PLUS_MONTHLY_1', 'NSE_PREMIUM_PLUS_MONTHLY_3', 'NSE_PREMIUM_PLUS_MONTHLY_6', 'NSE_PREMIUM_PLUS_MONTHLY_12', 'NSE_PREMIUM_PLUS_STOCKS_MONTHLY_1', 'NSE_PREMIUM_PLUS_STOCKS_MONTHLY_3', 'NSE_PREMIUM_PLUS_STOCKS_MONTHLY_6', 'NSE_PREMIUM_PLUS_STOCKS_MONTHLY_12', 'NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1', 'NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3', 'NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6', 'NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12', 'NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1', 'NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3', 'NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6', 'NSE_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12', 'VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1', 'VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3', 'VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12', 'VMR_ECOURSE', 'VMR_VTRENDER_ECOURSE', 'VMR_PREMIUM_PLUS_MONTHLY_1', 'VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_DAILY_8', 'NFP_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12'],
      roleList: ["basic", "fast_data", "pro_1", "pro_2"],
      resourceList: ["vmr_ecourse", "orderflow_both", "orderflow_index", "orderflow_stocks"],
      payList: ["UPI", "CCAVENUE", "PAYNIMO"],
    });
    const { is_valid, user_data, sub_data, planList, roleList, resourceList, payList } = planState;

    const [adminQueryState, setAdminQueryState] = useState({
      is_success: false,
      response_data: undefined
    });
    const { is_success, response_data } = adminQueryState;

    const [rowData,setRowData]=useState(data);
    const [userColumnDef,setUserColumnDef]=useState(getUserListColumnDef())

    const stateRef = useRef(state);
    const orderStateRef = useRef(orderState);
    const planStateRef = useRef(planState);
    const adminQueryStateRef = useRef(adminQueryState);

    const handleClose = (event, reason) => {
      setMsgState({...msgState,open:false});
    };
          
    const onGridReady = params => {
      setGridAPIOptions(params.api);
      setColumnAPIOptions(params.columnApi);
    };

    const handleOrderIdChange=(event)=>{
      setOrderId(event.target.value);
    }

    const handleRefNoChange=(event)=>{
      setRefNo(event.target.value);
    }

    const handleEmailIdChange=(event)=>{
      setEmailId(event.target.value);
    }
    const handleAdminQueryChange=(event)=>{
      setUserAdminQuery(event.target.value);
    }

    const handlePlanNameChange=(event)=>{
      setPlanName(event.target.value);
    }

    const handlePayTypeChange=(event)=>{
      setPayType(event.target.value);
    }

    const handleAmountChange=(event)=>{
      setAmount(event.target.value);
    }

    const handleFilterPlanNameChange=(event)=>{
      setFilterPlanName(event.target.value);
      setFilterRoleName("");
      setFilterResourceName("");
      console.log(event.target.value, filterPlanName)
      executeAPI(`${URL.USER_DATA}`,"POST",{"plan_name": event.target.value}) ;
    }

    const handleFilterRoleNameChange=(event)=>{
      setFilterRoleName(event.target.value);
      setFilterPlanName("");
      setFilterResourceName("");
      executeAPI(`${URL.USER_DATA}`,"POST",{"role_name": event.target.value}) ;
    }

    const handleFilterResourceNameChange=(event)=>{
      setFilterResourceName(event.target.value);
      setFilterPlanName("");
      setFilterRoleName("");
      executeAPI(`${URL.USER_DATA}`,"POST",{"resource_name": event.target.value}) ;
    }

    const GetOrderStatus=()=>{
      let data={"order_id": orderId}
      if(refNo!=undefined && refNo!="")
        data.ref_no = refNo;
      getOrderStatus(`${URL.ORDER_DATA}`,"POST",data);
    }

    const ClearOrderForm=()=>{
      setOrderId("");
      setRefNo("");
      setOrderState((prevState)=>({
        ...prevState,
        order_data:undefined,
        cca_data:undefined,
        order_available:false,
      }))
    }

    const CheckUserDetails=()=>{
      let data={"email_id": emailId};
      getPlanSubStatus(`${URL.USER_SUB_CHECK}`,"POST",data);
    }

    const GetUserAdminQueryResponse=()=>{
      let data={"admin_query": userAdminQuery};
      getUserAdminQueryResponse(`${URL.USER_ADMIN_QUERY}`,"POST",data);
    }

    const CheckUserPlanDetails=(exec)=>{
      let data={"email_id": emailId, "plan_name": planName, "type": payType, "exec_cmd": exec};
      if(orderId!=undefined && orderId!="")
        data.order_id = orderId;
      if(refNo!=undefined && refNo!="")
        data.ref_no = refNo;
      if(amount!=undefined && amount!="")
        data.amount = amount;
      getPlanSubStatus(`${URL.USER_SUB_CHECK}`,"POST",data);
    }

    const ClearPlanForm=()=>{
      setEmailId("");
      setPlanName("");
      setPayType("");
      setAmount("");
      setPlanState((prevState)=>({
        ...prevState,
        is_valid: false,
        user_data: undefined,
        sub_data: undefined,
      }))
      ClearOrderForm();
    }

    const ClearSearchForm=()=>{
      setFilterPlanName("");
      setFilterRoleName("");
      setFilterResourceName("");
      executeAPI(`${URL.USER_DATA}`,"POST",{}) ;
    }

    const ClearAdminQueryField=()=>{
      setUserAdminQuery("");
      setAdminQueryState((prevState)=>({
        ...prevState,
        is_success: false,
        response_data: undefined,
      }))
    }
    
    useEffect(()=>{
        executeAPI(`${URL.USER_DATA}`,"POST",{}) ;
    },[])

  useEffect(() => {
      if(loaded){
        console.log("loaded data ",responseData);
        if(responseData!=null){
              setState((prevState)=>({
                ...prevState,
                data:responseData.data,
                user_stats:responseData.stats,
                isLoading:false  
              }))
              setRowData(responseData.data);
        }
        else if(error!==null){
          console.log("Error data=",error);
            setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
            //if unauthorized then redirec it to login page
            if(error?.response?.status === 401 || error?.response?.status === 403){
              console.log("status received =",error?.response?.status)
              navigate(from, { replace: true });
            }
        }
        reset();
      }
  },[loaded,responseData]);


  useEffect(() => {
    orderStateRef.current = orderState;

    if(loadedOrderReq){
      console.log("loaded data ",responseOrderReq);
      if(responseOrderReq!=null){
           setOrderState((prevState)=>({
              ...prevState,
              order_data:responseOrderReq.data,
              cca_data:responseOrderReq.cca_data,
              order_available:responseOrderReq.success,
           }))
      }
      else if(errorOrderReq!==null){
        console.log("Error data=",errorOrderReq);
          setMsgState({open:true,msg:errorOrderReq?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
          //if unauthorized then redirec it to login page
          if(errorOrderReq?.response?.status === 401 || errorOrderReq?.response?.status === 403){
            console.log("status received =",errorOrderReq?.response?.status)
            navigate(from, { replace: true });
          }
      }
      resetOrderReq();
    }
  },[loadedOrderReq,responseOrderReq]);

  useEffect(() => {
    planStateRef.current = planState;

    if(loadedPlanSubReq){
      console.log("loaded data ",responsePlanSubReq);
      if(responsePlanSubReq!=null){
           setPlanState((prevState)=>({
              ...prevState,
              is_valid: responsePlanSubReq.success,
              user_data: responsePlanSubReq.user_data,
              sub_data: responsePlanSubReq.sub_data,
              // planList: ["PREMIUM_MONTHLY_1", "PREMIUM_MONTHLY_6", "PREMIUM_MONTHLY_12", "PREMIUM_PLUS_MONTHLY_1", "PREMIUM_PLUS_MONTHLY_6", "PREMIUM_PLUS_MONTHLY_12"],
              // payList: ["UPI", "CCAVENUE"],
           }));
           if(payType == "CCAVENUE"){
            setOrderState((prevState)=>({
                ...prevState,
                order_data:responsePlanSubReq.data,
                cca_data:responsePlanSubReq.cca_data,
                order_available:responsePlanSubReq.success,
            }))
           }
          //  if(responsePlanSubReq.success && responsePlanSubReq.message != undefined)
          //    setMsgState({open:true, msg:responsePlanSubReq.message, severity:"info"});
      }
      else if(errorPlanSubReq!==null){
        console.log("Error data=",errorPlanSubReq);
          setMsgState({open:true,msg:errorPlanSubReq?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
          //if unauthorized then redirec it to login page
          if(errorPlanSubReq?.response?.status === 401 || errorPlanSubReq?.response?.status === 403){
            console.log("status received =",errorPlanSubReq?.response?.status)
            navigate(from, { replace: true });
          }
      }
      resetPlanSubReq();
    }
  },[loadedPlanSubReq,responsePlanSubReq]);

  useEffect(() => {
    document.title = "User Admin";
  }, []);

  useEffect(() => {
    adminQueryStateRef.current = adminQueryState;
    if(loadedAdminQueryReq){
      console.log("loaded data ",responseAdminQueryReq);
      if(responseAdminQueryReq!=null){
          setAdminQueryState((prevState)=>({
              ...prevState,
              is_success: responseAdminQueryReq.success,
              response_data: responseAdminQueryReq.response_data,
          }));
        }
          //  if(responsePlanSubReq.success && responsePlanSubReq.message != undefined)
          //    setMsgState({open:true, msg:responsePlanSubReq.message, severity:"info"});
      }
      else if(errorAdminQueryReq!==null){
        console.log("Error data=",errorAdminQueryReq);
          setMsgState({open:true,msg:errorPlanSubReq?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"info"});
          //if unauthorized then redirect it to login page
          if(errorAdminQueryReq?.response?.status === 401 || errorAdminQueryReq?.response?.status === 403){
            console.log("status received =",errorAdminQueryReq?.response?.status)
            navigate(from, { replace: true });
          }
      }
      resetAdminQueryReq();
  },[loadedAdminQueryReq,responseAdminQueryReq]);

  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, TooltipJS, Legend);

  // Sample markdown with chart, image, and table
  const markdownContent = `
###  Here's a breakdown of new user registrations from January 2023 to May 2024, along with insights and a chart.

**Total Registered Users:** 1686  
**Total Activated Users:** 1630  
**Overall Activation Rate:** 96.68%

Here's the month-wise new user registration data:

| Month    | Total Registrations | Activated Registrations | Activation Rate (%) |
|----------|---------------------|-------------------------|---------------------|
| Jan-2023 | 7                   | 7                       | 100.00              |
| Feb-2023 | 14                  | 14                      | 100.00              |
| Mar-2023 | 240                 | 232                     | 96.67               |
| Apr-2023 | 92                  | 87                      | 94.57               |
| May-2023 | 64                  | 62                      | 96.88               |
| Jun-2023 | 72                  | 68                      | 94.44               |
| Jul-2023 | 108                 | 105                     | 97.22               |
| Aug-2023 | 120                 | 116                     | 96.67               |
| Sep-2023 | 179                 | 174                     | 97.21               |
| Oct-2023 | 200                 | 194                     | 97.00               |
| Nov-2023 | 191                 | 186                     | 97.38               |
| Dec-2023 | 158                 | 153                     | 96.84               |
| Jan-2024 | 104                 | 101                     | 97.12               |
| Feb-2024 | 102                 | 99                      | 97.06               |
| Mar-2024 | 93                  | 89                      | 95.70               |
| Apr-2024 | 88                  | 87                      | 98.86               |
| May-2024 | 55                  | 55                      | 100.00              |

**Key Insights:**

*   **Significant Growth in March 2023:** There was a substantial surge in new user registrations in March 2023, reaching 240 users, which is notably higher than the preceding months. This could be attributed to a successful marketing campaign, a new feature launch, or a favorable market event during that period.
*   **Consistent Performance:** After the March 2023 peak, registrations stabilized to a consistent range, generally between 50 and 200 users per month.
*   **High Activation Rates:** The activation rate remained consistently high across all months, mostly above 94%, indicating that a large majority of registered users successfully activated their accounts. This suggests a smooth onboarding process.
*   **Recent Trends (2024):** Registrations in the first few months of 2024 (January, February, March, April, May) show a slight decrease compared to the higher numbers seen in late 2023 (Sept-Nov 2023). May 2024 shows the lowest registration count during the period analyzed. It would be beneficial to investigate the reasons for this recent decline, such as changes in marketing efforts or market conditions.

Here's a bar chart visualizing the month-wise user registration trend:

\`\`\`chart
{
  "type": "bar",
  "data": {
    "labels": ["Jan-2023", "Feb-2023", "Mar-2023", "Apr-2023", "May-2023", "Jun-2023", "Jul-2023", "Aug-2023", "Sep-2023", "Oct-2023", "Nov-2023", "Dec-2023", "Jan-2024", "Feb-2024", "Mar-2024", "Apr-2024", "May-2024"],
    "datasets": [
      {
        "label": "Total Registrations",
        "data": [7, 14, 240, 92, 64, 72, 108, 120, 179, 200, 191, 158, 104, 102, 93, 88, 55],
        "backgroundColor": "rgba(75, 192, 192, 0.6)"
      },
      {
        "label": "Activated Registrations",
        "data": [7, 14, 232, 87, 62, 68, 105, 116, 174, 194, 186, 153, 101, 99, 89, 87, 55],
        "backgroundColor": "rgba(153, 102, 255, 0.6)"
      }
    ]
  },
  "options": {
    "responsive": true,
    "plugins": {
      "title": {
        "display": true,
        "text": "Monthly New User Registrations (Jan 2023 - May 2024)"
      }
    },
    "scales": {
      "x": {
        "title": {
          "display": true,
          "text": "Month"
        }
      },
      "y": {
        "title": {
          "display": true,
          "text": "Number of Users"
        },
        "beginAtZero": true
      }
    }
  }
}
\`\`\`
`;

const markdownContent1 = `
**Monthly User Registration Summary (January 2023 - October 2023)**

| Month     | Total Registrations | Activated Users | Not Activated Users | Activation Rate (%) |
|-----------|---------------------|-----------------|---------------------|---------------------|
| January   | 7                   | 7               | 0                   | 100.00%             |
| February  | 14                  | 14              | 0                   | 100.00%             |
| March     | 248                 | 237             | 11                  | 95.56%              |
| April     | 52                  | 48              | 4                   | 92.31%              |
| May       | 42                  | 38              | 4                   | 90.48%              |
| June      | 57                  | 54              | 3                   | 94.74%              |
| July      | 100                 | 93              | 7                   | 93.00%              |
| August    | 98                  | 95              | 3                   | 96.94%              |
| September | 118                 | 111             | 7                   | 94.07%              |
| October   | 120                 | 108             | 12                  | 90.00%              |
| **Total** | **856**             | **805**         | **51**              | **94.04%**          |

**General Trends Observed in Data:**

*   **Initial Low Volume & March Surge**: User registrations started low in January (7) and February (14) but experienced a significant spike in March, reaching 248 registrations. This dramatic increase suggests a highly successful marketing campaign, a major product launch, or a viral event during that month.
*   **Post-Surge Correction**: Following the peak in March, registrations saw a sharp decline in April (52) and May (42), indicating a normalization after the surge.
*   **Consistent Growth from June Onwards**: From June to October, there's a clear and consistent upward trend in user registrations, starting from 57 in June and steadily increasing to 120 in October. This indicates sustained growth, possibly due to ongoing marketing efforts or increasing organic reach.
*   **High Overall Activation Rate**: Across all months, the activation rate remains impressively high, averaging 94.04%. This suggests that the registration process is effective, and most users who sign up complete the activation steps.
*   **Slight Variation in Activation Rate**: While generally high, the activation rate saw its lowest point in May (90.48%) and October (90.00%), which might be worth investigating further to understand the reasons behind these slightly lower percentages.

**Seasonal Patterns:**

*   **Spring Peak (March)**: The most striking seasonal pattern is the very high number of registrations in March. This could indicate a recurring spring season surge, potentially driven by specific annual events, academic cycles (e.g., end of financial year in some regions), or a general increase in online activity during this period.
*   **Early Summer Dip (April-May)**: The drop in registrations during April and May might suggest a slight slowdown in new user acquisition as people enter the summer months, possibly due to holidays or reduced online engagement.
*   **Late Summer/Autumn Growth (June-October)**: The sustained growth from June through October suggests that late summer and autumn are strong periods for user acquisition, possibly due to a return to routine after summer, or increased marketing push leading into the end of the year.

**Conclusion:**

The data highlights a strong performance in user registrations, especially a significant event-driven surge in March 2023. The consistent growth observed from June onwards is a positive indicator of sustained user interest. Maintaining a high activation rate is crucial for converting registrations into active users. Further investigation into the specific factors driving the March surge and the slight dips in activation rates during certain months could provide valuable insights for optimizing future user acquisition and retention strategies.

**Bar Chart Visualization:**

\`\`\`json
{
  "chartType": "bar",
  "title": "Monthly User Registrations (Jan - Oct 2023)",
  "labels": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
  "datasets": [
    {
      "label": "Total Registrations",
      "data": [7, 14, 248, 52, 42, 57, 100, 98, 118, 120],
      "backgroundColor": "#42A5F5"
    },
    {
      "label": "Activated Users",
      "data": [7, 14, 237, 48, 38, 54, 93, 95, 111, 108],
      "backgroundColor": "#66BB6A"
    },
    {
      "label": "Not Activated Users",
      "data": [0, 0, 11, 4, 4, 3, 7, 3, 7, 12],
      "backgroundColor": "#EF5350"
    }
  ]
}
\`\`\`
`

const markdownContent2 = `

### User Registration Overview for 2024

A total of **1103** users registered in 2024.
Out of these, **1031** users successfully activated their accounts, resulting in an activation rate of approximately **93.47%**.
There are **72** non-activated users, which is approximately **6.53%** of the total registrations.

### Monthly User Registration and Activation Trend

The following table provides a month-wise breakdown of new registrations, activated users, and non-activated users:

| Month     | Total Registrations | Activated Users | Non-Activated Users |
|-----------|---------------------|-----------------|---------------------|
| January   | 112                 | 104             | 8                   |
| February  | 117                 | 112             | 5                   |
| March     | 104                 | 97              | 7                   |
| April     | 110                 | 104             | 6                   |
| May       | 117                 | 108             | 9                   |
| June      | 102                 | 98              | 4                   |
| July      | 96                  | 88              | 8                   |
| August    | 110                 | 103             | 7                   |
| September | 69                  | 65              | 4                   |
| October   | 64                  | 60              | 4                   |
| November  | 46                  | 42              | 4                   |
| December  | 56                  | 50              | 6                   |

### Registration Trend Chart

\`\`\`mermaid
{
  "chart": {
    "type": "bar",
    "data": {
      "labels": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      "datasets": [
        {
          "label": "Activated Users",
          "data": [104, 112, 97, 104, 108, 98, 88, 103, 65, 60, 42, 50],
          "backgroundColor": "rgba(75, 192, 192, 0.6)"
        },
        {
          "label": "Non-Activated Users",
          "data": [8, 5, 7, 6, 9, 4, 8, 7, 4, 4, 4, 6],
          "backgroundColor": "rgba(255, 99, 132, 0.6)"
        }
      ]
    },
    "options": {
      "responsive": true,
      "indexAxis": "x",
      "scales": {
        "x": {
          "stacked": true,
          "title": {
            "display": true,
            "text": "Month"
          }
        },
        "y": {
          "stacked": true,
          "beginAtZero": true,
          "title": {
            "display": true,
            "text": "Number of Users"
          }
        }
      },
      "plugins": {
        "title": {
          "display": true,
          "text": "Monthly User Registrations and Activation Status (2024)"
        }
      }
    }
  }
}
\`\`\`
### Useful Insights

1.  **Consistent High Activation Rate**: Across all months, the activation rate remains consistently high, generally above 90%. This indicates that the onboarding and activation process for new users is effective.
2.  **Peak Registration Periods**: The months of February and May show the highest number of new registrations (117 users each). This could indicate successful marketing campaigns or seasonal trends during these periods.
3.  **Decline in Latter Half**: There is a noticeable decline in new user registrations in the latter half of the year, particularly from September to November, with November recording the lowest registrations (46 users). This might be due to various factors such as reduced marketing efforts, seasonal user behavior, or increased competition.
4.  **Steady Non-Activation Numbers**: While total registrations fluctuate significantly, the number of non-activated users remains relatively low and stable, typically between 4 and 9 users per month. This suggests that the issues preventing activation affect a small and consistent portion of new users, rather than being linked to overall registration volume.
5.  **Opportunity for Growth**: Analyzing the reasons for the decline in registrations during the latter part of the year could uncover opportunities to optimize marketing strategies or user acquisition efforts to maintain a higher registration volume throughout the year. Additionally, understanding the common reasons for the small percentage of non-activated users could help further improve the activation rate.

`

const markdownContent3 = `
### Mermaid Flowchart of Monthly Registrations

\`\`\`mermaid
graph TD
    A[Jan 2024: 118] -->|118| B(Chart);
    C[Feb 2024: 121] -->|121| B;
    D[Mar 2024: 118] -->|118| B;
    E[Apr 2024: 105] -->|105| B;
    F[May 2024: 107] -->|107| B;
    G[Jun 2024: 103] -->|103| B;
    H[Jul 2024: 87] -->|87| B;
    I[Aug 2024: 112] -->|112| B;
    J[Sep 2024: 85] -->|85| B;
    K[Oct 2024: 81] -->|81| B;
    L[Nov 2024: 66] -->|66| B;
    M[Dec 2024: 76] -->|76| B;
    N[Jan 2025: 54] -->|54| B;
    O[Feb 2025: 50] -->|50| B;
    P[Mar 2025: 65] -->|65| B;
    Q[Apr 2025: 56] -->|56| B;
    R[May 2025: 62] -->|62| B;
    S[Jun 2025: 50] -->|50| B;
    T[Jul 2025: 16] -->|16| B;

    subgraph Monthly User Registrations
        direction LR
        Jan24(Jan 2024)---118;
        Feb24(Feb 2024)---121;
        Mar24(Mar 2024)---118;
        Apr24(Apr 2024)---105;
        May24(May 2024)---107;
        Jun24(Jun 2024)---103;
        Jul24(Jul 2024)---87;
        Aug24(Aug 2024)---112;
        Sep24(Sep 2024)---85;
        Oct24(Oct 2024)---81;
        Nov24(Nov 2024)---66;
        Dec24(Dec 2024)---76;
        Jan25(Jan 2025)---54;
        Feb25(Feb 2025)---50;
        Mar25(Mar 2025)---65;
        Apr25(Apr 2025)---56;
        May25(May 2025)---62;
        Jun25(Jun 2025)---50;
        Jul25(Jul 2025)---16;
    end
\`\`\`
`;

// ============================
// Mermaid Component
// ============================
const MermaidRenderer = ({ code }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      mermaid.initialize({ startOnLoad: false });
      try {
        mermaid.run({ nodes: [ref.current] });
      } catch (e) {
        console.error('Mermaid rendering error:', e);
      }
    }
  }, [code]);

  return <div className="mermaid" ref={ref}>{code}</div>;
};

// ==========================
// Chart Renderer Component
// ==========================
const ChartRenderer = ({ value }) => {
  let rawConfig;

  try {
    rawConfig = JSON.parse(value);
  } catch (err) {
    return <pre style={{ color: 'red' }}>Invalid JSON: {err.message}</pre>;
  }

  const config = rawConfig.chart || rawConfig;
  const type = config.type || config.chartType || 'bar';
  const data = config.data || { labels: config.labels || [], datasets: config.datasets || [] };
  const options = config.options || {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: config.title || 'Chart'
      }
    }
  };

  if (type !== 'bar') {
    return <pre style={{ color: 'orange' }}>Only bar charts are supported</pre>;
  }

  return (
    <div style={{ margin: '2rem 0' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

// ============================
// Markdown Renderer
// ============================
const MarkdownRenderer = ({ content }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        code({ inline, className = '', children }) {
          const lang = className.replace('language-', '');
          const raw = Array.isArray(children) ? children.join('') : children;

          if (lang === 'mermaid' && raw.trim().startsWith('graph')) {
            return <MermaidRenderer code={raw.trim()} />;
          }

          const isJSONChart = ['json', 'chart', 'mermaid'].includes(lang) &&
            raw.includes('"chartType"') || raw.includes('"type"') || raw.includes('"datasets"');

          if (isJSONChart) {
            return <ChartRenderer value={raw} />;
          }

          return <code className={className}>{children}</code>;
        }
      }}
    >
      {content}
    </ReactMarkdown>
  );
};




    return(
        <>
          
          <div style={{width:"100%",height:  `calc(100% - 64px)`,marginTop:"4px",marginLeft:"4px",marginRight:"10px"}}>
            {rowData!=undefined?
              <div className="ag-theme-alpine-dark" style={{height:  `calc(100% - 8px)`,marginLeft:"4px",marginRight:"4px", marginTop:"4px", marginBottom:"20px"}}>
                  <br/>
                  <TextField id="outlined-basic" size="small" label="Order ID" variant="outlined" 
                      value={orderId}
                      type="text"
                      onChange={handleOrderIdChange}
                      inputProps={{
                          style: {
                            padding:'0 4px 0 12px',  
                            height: "40px",
                            inputMode: 'numeric', 
                          },
                        }}
                      sx={{width:280,height:40,minHeight:30,ml:3}} />
                  
                  <TextField id="outlined-basic" size="small" label="Reference No" variant="outlined" 
                      value={refNo}
                      type="text"
                      onChange={handleRefNoChange}
                      inputProps={{
                          style: {
                            padding:'0 4px 0 12px',  
                            height: "40px",
                            inputMode: 'numeric', 
                          },
                        }}
                      sx={{width:200,height:40,minHeight:30,ml:3}} />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Button  variant="contained" onClick={()=>GetOrderStatus()} sx={{width:"180px",fontSize:12,fontColor:"#ffffff",height:30,mr:2,pl:1,pr:1,mt:1}}  >
                    Get Order Status Details
                  </Button>
                  <Button  variant="contained" onClick={()=>ClearOrderForm()} sx={{width:"80px",fontSize:12,fontColor:"#ffffff",height:30,mr:2,pl:1,pr:1,mt:1}}  >
                    Clear
                  </Button>
                  <br/><br/>
                  <Box sx={{display:"flex",justifyContent:'left',alignItems:'left'}}>
                    <Box sx={{mt:2,ml:4,display:'flex',justifyContent:'left',alignItems:'left',flexDirection:"column",height:"650px"}}>
                    <Typography>There are currently {user_stats.active_users} Verified and Active Users out of {user_stats.total_users} total Users. 
                    <br/>Number of users active in last 3 months: {user_stats.recently_active_users}.
                    <br/>Number of users active in last 30 days: {user_stats.active_users_30days}.
                    <br/>Plan wise subscriptions breakup for {user_stats.total_subscribers} users ({user_stats.premium_count} Premium & {user_stats.premium_plus_count} Premium + & {user_stats.premium_plus_orderflow_count} have Orderflow):
                    <br/>Premium Plan subscriptions:
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 Month: INDEX / INDEX_STOCKS: &nbsp;&nbsp;{user_stats.plan_specific_count.PREMIUM_MONTHLY_1+user_stats.plan_specific_count.PREMIUM_INDEX_MONTHLY_1}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_STOCKS_MONTHLY_1+user_stats.plan_specific_count.PREMIUM_INDEX_STOCKS_MONTHLY_1}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;3 Months: INDEX / INDEX_STOCKS: &nbsp;&nbsp;{user_stats.plan_specific_count.PREMIUM_MONTHLY_3+user_stats.plan_specific_count.PREMIUM_INDEX_MONTHLY_3}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_STOCKS_MONTHLY_3+user_stats.plan_specific_count.PREMIUM_INDEX_STOCKS_MONTHLY_3}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;6 Months: INDEX / INDEX_STOCKS: &nbsp;&nbsp;{user_stats.plan_specific_count.PREMIUM_MONTHLY_6+user_stats.plan_specific_count.PREMIUM_INDEX_MONTHLY_6}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_STOCKS_MONTHLY_6+user_stats.plan_specific_count.PREMIUM_INDEX_STOCKS_MONTHLY_6}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;12 Months: INDEX / INDEX_STOCKS: &nbsp;&nbsp;{user_stats.plan_specific_count.PREMIUM_MONTHLY_12+user_stats.plan_specific_count.PREMIUM_INDEX_MONTHLY_12}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_STOCKS_MONTHLY_12+user_stats.plan_specific_count.PREMIUM_INDEX_STOCKS_MONTHLY_12}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;Higher Plan with ADD-ON_STOCKS: &nbsp;&nbsp;{user_stats.plan_specific_count.STOCKS_MONTHLY_1}
                    <br/>Premium+ Plan subscriptions (:INTERNATIONAL_COUNT):
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 Month: No_OF / INDEX_OF / INDEX_STOCKS_OF: &nbsp;&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_MONTHLY_1}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_1}:{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_1}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1}:{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_1}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;3 Months: No_OF / INDEX_OF / INDEX_STOCKS_OF: &nbsp;&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_MONTHLY_3}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_3}:{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_3}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3}:{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_3}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;6 Months: No_OF / INDEX_OF / INDEX_STOCKS_OF: &nbsp;&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_MONTHLY_6}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_6}:{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_6}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_6}:{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_6}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;12 Months: No_OF / INDEX_OF / INDEX_STOCKS_OF: &nbsp;&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_MONTHLY_12}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_MONTHLY_12}:{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_INTERNATIONAL_MONTHLY_12}&nbsp;/&nbsp;{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12+user_stats.plan_specific_count.NFP_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12}:{user_stats.plan_specific_count.PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_INTERNATIONAL_MONTHLY_12}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;Higher Plan with 1 Month ADD-ON INDEX_OF: &nbsp;&nbsp;{user_stats.plan_specific_count.ORDERFLOW_INDEX_MONTHLY_1}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;Higher Plan with 1 Month INDEX_STOCKS_OF: &nbsp;&nbsp;{user_stats.plan_specific_count.ORDERFLOW_INDEX_STOCKS_MONTHLY_1}
                    <br/>ECourse subscriptions (paid via Vtrender Charts): &nbsp;&nbsp;{user_stats.plan_specific_count.VMR_ECOURSE}
                    <br/><br/>VMR subscriptions (Total: {user_stats.plan_specific_count.VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1+user_stats.plan_specific_count.VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3+user_stats.plan_specific_count.VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12}):
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 Month: &nbsp;&nbsp;{user_stats.plan_specific_count.VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_1}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;3 Months: &nbsp;&nbsp;{user_stats.plan_specific_count.VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_3}
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;12 Months: &nbsp;&nbsp;{user_stats.plan_specific_count.VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_STOCKS_MONTHLY_12}
                    <br/>Complementary with ECourse, VMR_PREMIUM_PLUS_MONTHLY_1 (active count): &nbsp;&nbsp;{user_stats.plan_specific_count.VMR_PREMIUM_PLUS_MONTHLY_1}
                    <br/>Complementary with ECourse, VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_DAILY_8 (active count): &nbsp;&nbsp;{user_stats.plan_specific_count.VMR_PREMIUM_PLUS_ORDERFLOW_INDEX_DAILY_8}
                    </Typography>
                    </Box>
                    
                    {order_available? 
                      <>
                      <Box sx={{ml:8,display:'flex',justifyContent:'left',alignItems:'left',flexDirection:"column",height:"400px",overflow:'auto'}}>
                        <Typography>
                        <pre>Order Details in DB:<br/>{JSON.stringify(order_data, null, 2)}</pre>
                        </Typography>
                      </Box>
                      <Box sx={{ml:4,display:'flex',justifyContent:'left',alignItems:'left',flexDirection:"column",height:"400px",overflow:'auto'}}>
                      <Typography>
                        <pre>Order Details from CCAvenues server:<br/>{JSON.stringify(cca_data, null, 2)}</pre> 
                      </Typography>
                      </Box>
                      </>
                      : <></>}
                    
                  </Box>
                  <br/><br/>
                  <TextField required id="outlined-basic" size="small" label="Email ID" variant="outlined" 
                      value={emailId}
                      type="text"
                      onChange={handleEmailIdChange}
                      inputProps={{
                          style: {
                            padding:'0 4px 0 12px',  
                            height: "40px",
                            inputMode: 'numeric', 
                          },
                        }}
                      sx={{width:260,height:40,minHeight:30,ml:3}} />
                  <Button  variant="contained" onClick={()=>CheckUserDetails()} sx={{width:"200px",fontSize:12,fontColor:"#ffffff",ml:4,height:30,mr:2,pl:1,pr:1,mt:1}}  >
                    Check User Details
                  </Button>
                  <FormControl required size="medium" sx={{ width:"420px",height:"40px",minWidth:'420px',ml:3,mt:0 }}>
                  <InputLabel id="demo-simple-select-label" sx={{ width:"420px",height:"40px",minWidth:'420px',ml:0,mt:-1 }}>Plan Name</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={planList.find(item=>item==planName)||''}
                    label="Plan Name"
                    placeholder="Select a Plan..."
                    MenuProps={MenuProps}
                    sx={{width:420,height:"40px",ml:0,mb:1}}
                    onChange={(event)=>handlePlanNameChange(event)}
                  >
                    {planList.map((item,index) => (
                      <MenuItem key ={item} value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                  </FormControl>
                  <FormControl required size="medium" sx={{ width:"200px",height:"40px",minWidth:'200px',ml:3,mt:0 }}>
                  <InputLabel id="demo-simple-select-label" sx={{ width:"120px",height:"40px",minWidth:'120px',ml:0,mt:-1 }}>Pay Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={payList.find(item=>item==payType)||''}
                    label="Pay Type"
                    placeholder="Select a Type..."
                    MenuProps={MenuProps}
                    sx={{width:200,height:"40px",ml:0,mb:1}}
                    onChange={(event)=>handlePayTypeChange(event)}
                  >
                    {payList.map((item,index) => (
                      <MenuItem key ={item} value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                  </FormControl>
                  {payType=="UPI" || payType=="PAYNIMO"?
                    <>
                    <TextField required id="outlined-basic" size="small" label="Amount" variant="outlined" 
                      value={amount}
                      type="text"
                      onChange={handleAmountChange}
                      inputProps={{
                          style: {
                            padding:'0 4px 0 12px',  
                            height: "40px",
                            inputMode: 'numeric', 
                          },
                        }}
                      sx={{width:260,height:40,minHeight:30,ml:3}} />
                    </>
                  : payType=="CCAVENUE"?
                    <>
                    <TextField required id="outlined-basic" size="small" label="Order ID" variant="outlined" 
                      value={orderId}
                      type="text"
                      onChange={handleOrderIdChange}
                      inputProps={{
                          style: {
                            padding:'0 4px 0 12px',  
                            height: "40px",
                            inputMode: 'numeric', 
                          },
                        }}
                      sx={{width:280,height:40,minHeight:30,ml:3}} />
                    <TextField required id="outlined-basic" size="small" label="Reference No" variant="outlined" 
                      value={refNo}
                      type="text"
                      onChange={handleRefNoChange}
                      inputProps={{
                          style: {
                            padding:'0 4px 0 12px',  
                            height: "40px",
                            inputMode: 'numeric', 
                          },
                        }}
                      sx={{width:200,height:40,minHeight:30,ml:3}} />
                    </>
                    : <></>
                  }
                  
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Button  variant="contained" onClick={()=>CheckUserPlanDetails(false)} sx={{width:"200px",fontSize:12,fontColor:"#ffffff",height:30,mr:2,pl:1,pr:1,mt:1}}  >
                    Check Order and User Details
                  </Button>
                  <Button  variant="contained" onClick={()=>ClearPlanForm()} sx={{width:"80px",fontSize:12,fontColor:"#ffffff",height:30,mr:2,pl:1,pr:1,mt:1}}  >
                    Clear
                  </Button>
                  <br/><br/>
                  {is_valid?
                    <>
                    <Box sx={{display:"flex",justifyContent:'left',alignItems:'left'}}>
                      <Box sx={{mt:2,ml:4,display:'flex',justifyContent:'left',alignItems:'left',flexDirection:"column",height:"400px",overflow:'auto'}}>
                      <Typography>
                        <pre>User Details in DB:<br/>{JSON.stringify(user_data, null, 2)}</pre>
                      </Typography>
                      </Box>
                      <Box sx={{mt:2,ml:8,display:'flex',justifyContent:'left',alignItems:'left',flexDirection:"column",height:"400px",overflow:'auto'}}>
                      <Typography>
                        <pre>Plan Details in DB:<br/>{JSON.stringify(sub_data, null, 2)}</pre>
                      </Typography>
                      </Box>
                      <Box sx={{mt:4,ml:4,display:'flex',justifyContent:'left',alignItems:'left',flexDirection:"column"}}>
                      <Typography>
                      <Button  variant="contained" onClick={()=>CheckUserPlanDetails(true)} sx={{width:"80px",fontSize:12,fontColor:"#ffffff",height:30,mr:2,pl:1,pr:1,mt:1}}  >
                        Subscribe
                      </Button>
                      </Typography>
                      </Box>
                    </Box>

                    
                    <br/><br/>
                    </>
                    :
                    <></>

                  }
                  <br/><br/>
                  {isAdmin? 
                  <Box>
                  <TextField required id="outlined-basic" size="small" label="Ask me any question about User Registration and Subscription data patterns" variant="outlined" 
                    value={userAdminQuery}
                    type="text"
                    onChange={handleAdminQueryChange}
                    inputProps={{
                        style: {
                          padding:'0 4px 0 12px',  
                          height: "40px",
                          inputMode: 'numeric', 
                        },
                      }}
                    sx={{width:800,height:40,minHeight:30,ml:3}} />
                  <Button  variant="contained" onClick={()=>GetUserAdminQueryResponse()} sx={{width:"200px",fontSize:14,fontColor:"#ffffff",ml:4,height:30,mr:2,pl:1,pr:1,mt:1}}  >
                    Get Response
                  </Button>
                  <Button  variant="contained" onClick={()=>ClearAdminQueryField()} sx={{width:"80px",fontSize:12,fontColor:"#ffffff",height:30,mr:2,pl:1,pr:1,mt:1}}  >
                    Clear
                  </Button>
                  <Box sx={{marginTop:1,marginLeft:4}}>Eg: "Do a detailed analysis of the new user registrations from January 2024 to July 2025."</Box>
                  <Box sx={{marginTop:1,marginLeft:4}}>Eg: "Analyse the data of new users registered in 2025 who subscribed to a plan and analyse which plans they purchased."</Box>
                  <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif', fontSize:16, height: "40%", width: "80%" }}>
                    {/* <MarkdownRenderer content={markdownContent3} /> */}
                    <MarkdownRenderer content={response_data} />
                  </div>
                  </Box>
                  : 
                  <></>}
                  <br/><br/>
                  <Box>
                  <Typography>Select option to filter table (only the value from latest dropdown change is picked):
                  <FormControl size="medium" sx={{ width:"220px",height:"40px",minWidth:'220px',ml:3,mt:0 }}>
                  <InputLabel id="demo-simple-select-label" sx={{ width:"220px",height:"40px",minWidth:'220px',ml:0,mt:-1 }}>Role Name</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={roleList.find(item=>item==filterRoleName)||''}
                    label="Role Name"
                    placeholder="Select a Role..."
                    MenuProps={MenuProps}
                    sx={{width:220,height:"40px",ml:0,mb:1}}
                    onChange={(event)=>handleFilterRoleNameChange(event)}
                  >
                    {roleList.map((item,index) => (
                      <MenuItem key ={item} value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                  </FormControl>

                  <FormControl size="medium" sx={{ width:"220px",height:"40px",minWidth:'220px',ml:3,mt:0 }}>
                  <InputLabel id="demo-simple-select-label" sx={{ width:"220px",height:"40px",minWidth:'220px',ml:0,mt:-1 }}>Resource Name</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select1"
                    value={resourceList.find(item=>item==filterResourceName)||''}
                    label="Resource Name"
                    placeholder="Select a Resource..."
                    MenuProps={MenuProps}
                    sx={{width:220,height:"40px",ml:0,mb:1}}
                    onChange={(event)=>handleFilterResourceNameChange(event)}
                  >
                    {resourceList.map((item,index) => (
                      <MenuItem key ={item} value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                  </FormControl>

                  <FormControl size="medium" sx={{ width:"420px",height:"40px",minWidth:'420px',ml:3,mt:0 }}>
                  <InputLabel id="demo-simple-select-label" sx={{ width:"420px",height:"40px",minWidth:'420px',ml:0,mt:-1 }}>Plan Name</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={planList.find(item=>item==filterPlanName)||''}
                    label="Plan Name"
                    placeholder="Select a Plan..."
                    MenuProps={MenuProps}
                    sx={{width:420,height:"40px",ml:0,mb:1}}
                    onChange={(event)=>handleFilterPlanNameChange(event)}
                  >
                    {planList.map((item,index) => (
                      <MenuItem key ={item} value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                  </FormControl>
                  <Button  variant="contained" onClick={()=>ClearSearchForm()} sx={{width:"80px",fontSize:12,fontColor:"#ffffff",height:30,ml:2,pl:1,pr:1,mt:1}}  >
                    Reset
                  </Button>
                  </Typography>
                  </Box>
                  <br/><br/>
                  <AgGridReact
                    ref={gridRef}
                    onGridReady={onGridReady}
                    components={frameworkComponents}
                    rowHeight={ROW_HEIGHT}
                    headerHeight={HEADER_HEIGHT}
                    groupHeaderHeight={GROUP_HEADER_HEIGHT}
                    gridOptions={gridOptions}
                    rowData={rowData}
                    columnDefs={userColumnDef}/>
                  <br/><br/>

              </div>:
              <div style={{textAlign:"center", width:"100%"}}><CircularProgress sx={{marginTop:"10%"}}/>
              </div>
            }
      
          </div>
          
        
        <FooterToolbar sx={{borderTop: `1px solid ${theme.palette.primaryTheme.shade03}` }} >
        <Container >
        <Typography  variant="copyRight" align="center" >
          {WATERMARK_CONFIG.TABLE_TEXT}
          </Typography>
        </Container>
      </FooterToolbar>
      <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}}  open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION_SHORT} >
          <Alert  severity={severity} sx={{marginTop:"48px", width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
            {msg}
          </Alert>  
       </Snackbar>  
    </> 
      )
}